import React from "react";
import { Route, Routes } from "react-router-dom";
import ContactModal from "./contact-list/ContactModal";
import ContactDetails from "./contact-details/contact-details";

const ContactList = () => {
  return (
    <Routes>
      <Route path="/" element={<ContactModal />} />
      <Route
        path="/:id/details"
        element={
          <ContactDetails />
        }
      />
    </Routes>
  );
};

export default ContactList;
